<script lang="ts">
import {
  iButton,
  iButtonStyles,
  iButtonTypes,
  iButtonSizes,
  iIcon,
} from '@inscribe/signal';

export default {
  name: 'UpsellScreenMain',
  components: { iButton, iIcon },
  props: {
    icon: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    primaryButtonLabel: {
      type: String,
      required: true,
    },
    secondaryButtonLabel: {
      type: String,
    },
  },
  setup() {
    return {
      iButtonStyles,
      iButtonTypes,
      iButtonSizes,
    };
  },
};
</script>

<template>
  <div class="upsell-screen-main i-radius-2xl i-p-11">
    <i-icon :symbol="icon" :size="48" class="i-text-primary-120" />
    <div class="text-container d-flex flex-column i-mt-11 i-gap-6">
      <span class="i-text-heading-4 i-text-neutral-120">{{ title }}</span>
      <span class="i-text-body-2 i-text-neutral-120">{{ description }}</span>
    </div>
    <div class="button-container d-flex flex-row i-mt-9 i-gap-6">
      <i-button
        :label="primaryButtonLabel"
        :button-style="iButtonStyles.SOLID_DARK"
        :size="iButtonSizes.MEDIUM"
        :type="iButtonTypes.PRIMARY"
        @button-click="$emit('primary-button-clicked')"
      />
      <i-button
        :label="secondaryButtonLabel"
        :button-style="iButtonStyles.SOLID_LIGHT"
        :size="iButtonSizes.MEDIUM"
        :type="iButtonTypes.NEUTRAL"
        @button-click="$emit('secondary-button-clicked')"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.upsell-screen-main {
  position: relative;
  border: 1px solid $light-neutral-60;

  background-color: $light-neutral-10;
  overflow: hidden;
  z-index: 1;

  &::after {
    content: '';
    z-index: -1;
    position: absolute;
    bottom: -138px;
    right: -175px;
    width: 680px;
    height: 464px;
    background-image: url('../../../img/background_graphic.svg');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    transform: rotate(-11.19deg);
  }

  .text-container {
    max-width: 460px;
  }
}
</style>
